/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

/**
 * Bilingual 404 page. Rendered by the catch-all `*` route in App.tsx so
 * unknown URLs (which Cloudflare Pages rewrites to /index.html with a 200
 * via the SPA fallback) show a real "not found" hall instead of a blank page.
 */
export default function NotFound() {
  const { isRtl, localized } = useLanguage();

  useEffect(() => {
    document.title = isRtl ? "یافت نشد | راز و روان" : "Not Found | RazoRavan";
  }, [isRtl]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center" dir={isRtl ? "rtl" : "ltr"}>
      <div className="text-7xl font-black text-amber-500/20 font-mono select-none">404</div>
      <h1 className="text-2xl md:text-3xl font-extrabold text-amber-300 mt-4 font-sans">
        {isRtl ? "این کتیبه وجود ندارد" : "This inscription does not exist"}
      </h1>
      <p className="text-gray-400 text-sm mt-3 font-sans leading-relaxed">
        {isRtl
          ? "نشانی‌ای که به آن آمدی در تالار راز و روان یافت نشد؛ شاید نامش عوض شده یا اشتباه نوشته شده است."
          : "The address you came to was not found in the halls of RazoRavan."}
      </p>
      <Link
        to={localized("/")}
        className="inline-block mt-8 px-8 py-3.5 bg-gradient-to-r from-amber-400 to-amber-600 hover:from-amber-300 hover:to-amber-500 text-[#121212] font-bold text-sm rounded-full shadow-lg transition-all font-sans"
      >
        {isRtl ? "بازگشت به تالار اصلی" : "Back to Main Hall"}
      </Link>
    </div>
  );
}
